import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import { deprecatedProperty as t } from "../../core/deprecate.js";
import { clone as o } from "../../core/lang.js";
import s from "../../core/Logger.js";
import { property as r } from "../../core/accessorSupport/decorators/property.js";
import "../../core/accessorSupport/ensureType.js";
import { subclass as i } from "../../core/accessorSupport/decorators/subclass.js";
import l from "../../tasks/Locator.js";
import a from "./SearchSource.js";
import { getResults as c, getSuggestions as p } from "./support/locatorUtils.js";

var _n;

var u = "esri.widgets.Search.LocatorSearchSource",
    h = s.getLogger(u);

var d = _n = /*#__PURE__*/function (_a) {
  _inherits(n, _a);

  var _super = _createSuper(n);

  function n(e) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, e), _this.apiKey = null, _this.categories = null, _this.countryCode = null, _this.defaultZoomScale = null, _this.localSearchDisabled = !1, _this.locationType = null, _this.name = "", _this.placeholder = "", _this.searchTemplate = "", _this.singleLineFieldName = null, _this.suggestionsEnabled = null, _this.url = null, _this.zoomScale = null, _this.getResults = function (e, t) {
      return c(_objectSpread({
        source: _assertThisInitialized(_this)
      }, e), t);
    }, _this.getSuggestions = function (e, t) {
      return p(_objectSpread({
        source: _assertThisInitialized(_this)
      }, e), t);
    };
    return _this;
  }

  _createClass(n, [{
    key: "locator",
    get: function get() {
      return t(h, "locator", {
        replacement: "url",
        version: "4.22"
      }), this._get("locator");
    },
    set: function set(e) {
      t(h, "locator", {
        replacement: "url",
        version: "4.22"
      }), this._set("url", e.url), this._set("locator", e);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _n({
        apiKey: this.apiKey,
        autoNavigate: this.autoNavigate,
        filter: this.filter,
        maxResults: this.maxResults,
        maxSuggestions: this.maxSuggestions,
        minSuggestCharacters: this.minSuggestCharacters,
        outFields: this.outFields ? o(this.outFields) : null,
        placeholder: this.placeholder,
        popupEnabled: this.popupEnabled,
        prefix: this.prefix,
        resultGraphicEnabled: this.resultGraphicEnabled,
        resultSymbol: this.resultSymbol ? this.resultSymbol.clone() : null,
        suggestionsEnabled: this.suggestionsEnabled,
        suffix: this.suffix,
        withinViewEnabled: this.withinViewEnabled,
        categories: this.categories ? o(this.categories) : null,
        countryCode: this.countryCode,
        locationType: this.locationType,
        locator: this.locator,
        searchTemplate: this.searchTemplate,
        singleLineFieldName: this.singleLineFieldName,
        zoomScale: this.zoomScale
      });
    }
  }]);

  return n;
}(a);

e([r()], d.prototype, "apiKey", void 0), e([r()], d.prototype, "categories", void 0), e([r()], d.prototype, "countryCode", void 0), e([r({
  json: {
    write: !0
  }
})], d.prototype, "defaultZoomScale", void 0), e([r()], d.prototype, "localSearchDisabled", void 0), e([r({
  type: l,
  json: {
    read: !1,
    write: !1
  }
})], d.prototype, "locator", null), e([r()], d.prototype, "locationType", void 0), e([r({
  json: {
    write: !0
  }
})], d.prototype, "name", void 0), e([r({
  json: {
    write: !0
  }
})], d.prototype, "placeholder", void 0), e([r()], d.prototype, "searchTemplate", void 0), e([r({
  json: {
    write: !0
  }
})], d.prototype, "singleLineFieldName", void 0), e([r({
  json: {
    read: {
      source: "suggest"
    },
    write: {
      target: "suggest"
    }
  }
})], d.prototype, "suggestionsEnabled", void 0), e([r({
  json: {
    write: !0
  }
})], d.prototype, "url", void 0), e([r({
  json: {
    write: !0
  }
})], d.prototype, "zoomScale", void 0), d = _n = e([i(u)], d);
var m = d;
export { m as default };